import DropDown from './dropdown'
import Input from './input'
import InputSearch from './inputSearch'
import Password from './password'
import TextArea from './textarea'
import Upload from './upload'
import PhoneInput from './phone'
import OtpInput from './otp'
import ChooseBox from './choosebox'
import Checkbox from './checkbox'
import ChooseButton from './choosebutton'
import Switch from './switch'
import Map from './map'
import GroupCheckBox from './groupCheckBox'
import GroupRadioBox from './groupRadioBox'
import Editor from './editor'

export default {
  DropDown,
  Input,
  InputSearch,
  Password,
  TextArea,
  Upload,
  PhoneInput,
  OtpInput,
  ChooseBox,
  Checkbox,
  ChooseButton,
  Switch,
  Map,
  GroupCheckBox,
  GroupRadioBox,
  Editor,
}
